(function(){
function R(f){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',f);}else{f();}}
var BLOG_URL='/blogs/party-ideas';
var LABEL='View all our blogs';
function run(){
  // Desktop mega-menu: add a centered 'View all our blogs' link below the blog cards
  var panels=document.querySelectorAll('.mega-panel__items');
  for(var i=0;i<panels.length;i++){
    var p=panels[i];
    if(!p.querySelector('.pp-blog-viewall')){
      var blogCards=p.querySelectorAll('a.cta__link[href*="/blogs/"]');
      if(blogCards.length>=3){
        var wrap=document.createElement('div');
        wrap.className='pp-blog-viewall mega-panel__item';
        wrap.style.cssText='flex:0 0 100% !important;width:100%;grid-column:1 / -1;text-align:center;margin-top:16px;';
        var a=document.createElement('a');
        a.href=BLOG_URL;
        a.textContent=LABEL;
        a.style.cssText='display:inline-block;font-weight:700;text-decoration:underline;color:#0da1e2;font-size:1.05rem;';
        wrap.appendChild(a);
        p.appendChild(wrap);
      }
    }
  }
  // Mobile drawer: relabel the theme's built-in blog 'View all' button to match
  var mob=document.querySelectorAll('.drawer-nav__view-all a, a.drawer-nav__view-all');
  for(var k=0;k<mob.length;k++){
    var m=mob[k];var href=m.getAttribute('href')||'';
    if(/\/blogs\//.test(href) && m.textContent.trim()!==LABEL){m.textContent=LABEL;}
  }
}
function startObs(){var mo=new MutationObserver(function(){run();});mo.observe(document.body,{childList:true,subtree:true});}
R(function(){run();setTimeout(run,800);setTimeout(run,2000);startObs();});
})();
